var v1='<div><div id=PatientAccountFileUploadApp></div></div>';
angular.module('account.templates').run(['$templateCache', function ($templateCache) {$templateCache.put('src/app/file-upload/file-upload.html', v1);}]);
module.exports=v1